<i18n>
en:
  complete:
    msg: "Registration of the password is completed."
    before: "Please sign in"
    login: "here"
    after: "."
  password:
    label: "New password"
    hint: "8 or more alphanumeric symbols"
    confirm:
      label: "Re-enter password"
      error: "Passwords do not match"
  submit: "Regist"
ja:
  complete:
    msg: "パスワードの登録が完了しました。"
    before: " "
    login: "こちら"
    after: "からログインてください。"
  password:
    label: "パスワード"
    hint: "半角英数字を組み合わせた8桁以上で入力してください"
    confirm:
      label: "パスワード（確認）"
      error: "パスワードが一致しません"
  submit: "登録"
</i18n>

<template lang="pug">
  div.my-6
    v-container
      //- 正常終了
      template(v-if="isComplete")
        v-row
          v-col.mb-12.pb-12(cols="12" align="center")
            v-alert(dense outlined prominent type="success" border="bottom")
              div(v-html="$t('complete.msg')")
              |{{$t('complete.before')}}&nbsp;
              strong
                a(href="#" @click="$router.push({name: 'Login'})")|{{$t('complete.login')}}
              |&nbsp;{{$t('complete.after')}}

      //- 入力フォーム
      template(v-else)
        v-form(onsubmit="return false" v-model="valid")
          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-text-field.required(type="password" prepend-icon="fa-key" :label="$t('password.label')" persistent-hint :hint="$t('password.hint')" :rules="v($t('password.label'), ['required', 'password'])" :error="validPassword.error" :error-messages="validPassword.message" maxlength="32" v-model="forms.password")

          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-text-field.required(type="password" prepend-icon="fa-key" :label="$t('password.confirm.label')" :rules="v($t('password.confirm.label'), ['required'])" :error="validPassword.error" :error-messages="validPassword.message" maxlength="32" v-model="forms.passwordConfirm")

          //- 送信ボタン
          v-row(justify="center")
            v-col(cols="12" sm="6" md="4" xl="2")
              v-btn(x-large block color="primary" type="submit" @click="submit" :loading="isSubmit" :disabled="!valid")|{{$t('submit')}}

          //- エラーメッセージ
          v-row(v-if="errMsg")
            v-col(cols="12" align="center")
              v-alert.d-inline-block(dense outlined type="error")
                div(v-html="errMsg")
</template>

<script>
export default {
  data () {
    return {
      // 入力フォーム
      forms: {
        password: null,
        passwordConfirm: null
      },
      // 入力バリデーション
      valid: false,
      // 送信中
      isSubmit: false,
      // 完了
      isComplete: false,
      // エラーメッセージ
      errMsg: null
    }
  },
  computed: {
    /**
     * パスワードの検証
     */
    validPassword () {
      if (!this.forms.password ||
          !this.forms.passwordConfirm ||
          this.forms.password === this.forms.passwordConfirm) {
        return {
          error: false,
          message: null
        }
      } else {
        return {
          error: true,
          message: this.$t('password.confirm.error')
        }
      }
    }
  },
  methods: {
    /**
     * 送信
     */
    submit () {
      if (this.isSubmit) {
        return
      }

      this.isSubmit = true
      this.isComplete = false
      this.errMsg = null

      this.api.passRegist({
        password: this.forms.password,
        hash: this.$route.params.hash
      })
        .then(response => {
          this.isComplete = true
        })
        .catch(response => {
          this.errMsg = this.$t(`error.${response.functionError.errorCode}`)
        })
        .finally(() => {
          this.isSubmit = false
        })
    }
  }
}
</script>

<style lang="sass" scoped>
</style>
